const splitQuoteContext = (quoteContext, directQuote) => {
  if (!quoteContext || !directQuote) {
    return [{ text: quoteContext || '', isDirectQuote: false }];
  }

  const parts = [];
  let startIndex = 0;
  let quoteIndex = quoteContext.indexOf(directQuote);

  while (quoteIndex !== -1) {
    if (quoteIndex > startIndex) {
      parts.push({
        text: quoteContext.slice(startIndex, quoteIndex),
        isDirectQuote: false
      });
    }
    parts.push({ text: directQuote, isDirectQuote: true });
    startIndex = quoteIndex + directQuote.length;
    quoteIndex = quoteContext.indexOf(directQuote, startIndex);
  }

  if (startIndex < quoteContext.length) {
    parts.push({
      text: quoteContext.slice(startIndex),
      isDirectQuote: false
    });
  }

  return parts.length > 0
    ? parts
    : [{ text: quoteContext, isDirectQuote: false }];
};

const sourceAfterQuoteEdit = (source, directQuote) => ({
  ...source,
  directQuote,
  ...(source.quoteContext ? { quoteContext: '' } : {})
});

export { splitQuoteContext, sourceAfterQuoteEdit };
